import { render, staticRenderFns } from "./shopAfterSale.vue?vue&type=template&id=8fc76cce&scoped=true&"
import script from "./shopAfterSale.vue?vue&type=script&lang=js&"
export * from "./shopAfterSale.vue?vue&type=script&lang=js&"
import style0 from "./shopAfterSale.vue?vue&type=style&index=0&id=8fc76cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc76cce",
  null
  
)

export default component.exports